import { Button, Icon, makeStyles, useTheme } from '@rneui/themed'
import { t } from 'app/i18l'

export function FileFolderSearchBarButton({
  onPress,
}: {
  onPress: () => void
}) {
  const { theme } = useTheme()
  const styles = useStyles()
  return (
    <Button
      onPress={onPress}
      title={t('search')}
      icon={<Icon name="search" color={theme.colors.primary} />}
      iconRight
      containerStyle={styles.buttonContainer}
      buttonStyle={styles.button}
      titleStyle={styles.title}
    />
  )
}
const useStyles = makeStyles(theme => ({
  searchBarButtonContainer: {
    borderRadius: 50,
    padding: 5,
  },
  button: {
    borderRadius: 50,
    borderWidth: 0.5,
    borderColor: theme.colors.primary,
    backgroundColor:
      theme.mode === 'dark' ? theme.colors.grey11 : theme.colors.grey6,
  },
  buttonContainer: { borderRadius: 50, marginVertical: 5 },
  title: {
    flex: 1,
    textAlign: 'left',
    marginLeft: 10,
    color: theme.colors.black,
  },
}))
